import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { InnovationRequestService } from '../../innovation-requests/innovation-request.service';
import { InnovationRequestsFilterService } from '../../innovation-requests/innovation-requests-filter.service';
import { InnovationRequestDetailService } from '../innovation-request-detail.service';

@Component({
    selector: 'app-innovation-request-detail-header',
    templateUrl: './request-detail-header.component.html',
    standalone: true,
    imports: [
        ButtonDirective,
        TooltipModule,
        DatePipe,
        TranslateModule
    ]
})
export class InnovationRequestDetailHeaderComponent {

    get translatedStatus(): string {
        const status = `STATUS.${this.innovationRequestDetailService.request.personQuery.status}`;
        return this.translate.instant(status);
    }

    get translatedSubStatus(): string {
        const subStatus = `SUBSTATUS.${this.innovationRequestDetailService.request.personQuery.substatus}`;
        return this.translate.instant(subStatus);
    }

    get queryTypeTitle(): string {
        const { queryType, personType } = this.innovationRequestDetailService.request.personQuery;

        if (queryType === 'LegalPerson') {
            return this.translate.instant('PERSON_TYPES.02');
        } else if (queryType === 'PhysicalPerson') {
            const resolvedType = personType === '00' ? 'GUARANTOR' : personType;
            return this.translate.instant(`PERSON_TYPES.${resolvedType}`);
        } else {
            return this.translate.instant('PERSON_TYPES.UNKNOWN');
        }
    }

    constructor(
        public readonly innovationRequestDetailService: InnovationRequestDetailService,
        public readonly innovationRequestsFilterService: InnovationRequestsFilterService,
        public readonly innovationRequestService: InnovationRequestService,
        private readonly router: Router,
        private readonly translate: TranslateService
    ) { }

    navigateToRequests(): void {
        this.router.navigate(['/innovation']).catch(error => { console.error(error); });
    }
}
